import React from "react";
import Modal from "../../Modal";
import styles from "./styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../../features/LoaderSlice";
import { FormattedMessage, useIntl } from "react-intl";
import useCollect from "../../../hooks/useCollect";
const DeleteSubIdentitiesAliasesModal = ({
  deleteOpen,
  data = {},
  setDeleteOpen,
  getSubIdentitiesAliases,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const {
    identityCollect,
    handleCollectSuccessMessage,
    handleCollectErrorMessage,
  } = useCollect();
  const controller_code = useSelector((state) => state.controllers.controller);
  const customer_scope = useSelector((state) => state.controller.scope);
  const userDetails = useSelector(
    (state) => state.userDetailsReducer.userDetail
  );
  const { language } = userDetails;
  const { identity, type, value } = data;
  const deleteSubIdentitiesAliases = async () => {
    let deleteIdentity;
    if (identity === "Sub Identity") {
      deleteIdentity = {
        delete_sub_identities: [
          {
            type: type,
            value: value,
          },
        ],
      };
    } else {
      deleteIdentity = {
        delete_aliases: [
          {
            type: type,
            value: value,
          },
        ],
      };
    }
    const deletePayload = {
      value: userDetails.value,
      type: userDetails.type,
      language: language,
      customer_scope: customer_scope,
      controller_code: controller_code,
      collection_channel: "Truman UI",
      last_update_channel: "Truman UI",
    };
    dispatch(setLoader({ loading: true, label: "" }));
    identityCollect(deletePayload, false, false, deleteIdentity, false)
      .then((res) => {
        handleCollectSuccessMessage(res);
        dispatch(setLoader({ loading: false, label: "" }));
        getSubIdentitiesAliases();
        setDeleteOpen(false);
      })
      .catch((error) => {
        handleCollectErrorMessage(error);
        dispatch(setLoader({ loading: false, label: "" }));
        setDeleteOpen(false);
      });
  };

  return (
    <Modal
      title={intl.formatMessage({
        id: "label.confirmation",
        defaultMessage: "Confirmation",
      })}
      open={deleteOpen}
      setOpen={setDeleteOpen}
      okText={intl.formatMessage({
        id: "label.delete",
        defaultMessage: "Delete",
      })}
      cancelText={intl.formatMessage({
        id: "label.cancel",
        defaultMessage: "Cancel",
      })}
      onSubmit={deleteSubIdentitiesAliases}
      deletePrimary={true}
    >
      <h2 className={styles["delete-modal-heading"]}>
        <FormattedMessage
          id="delete.sub-id-alias.title"
          defaultMessage="Are you sure you want to delete this {identity}?"
          values={{ identity: identity }}
        />
      </h2>
      <p className={styles["delete-modal-message"]}>
        <FormattedMessage
          id="delete.sub-id-alias.description"
          defaultMessage="By clicking on delete, you will permanently remove this {identity}. This is an irreversible action."
          values={{ identity: identity }}
        />
      </p>
    </Modal>
  );
};

export default DeleteSubIdentitiesAliasesModal;
